/// <reference path="_references.ts"/>

module App {
	import UserSession = App.User.UserSession;
	import AppRootScope = App.Administrative.AppRootScope;

	const app = angular.module('field', [
		'ui.router',
		'ngCookies',
		'ngAnimate',
		'ngMessages',
		'ngMap',
		'authInterceptor',
		'utils',
		'login',
		'user',
		'appointment',
		'customer',
		'itemManagement',
		'priceGuide',
		'workOrder',
		'workOrderTemplate',
		'payment',
		'history',
		'timeclock',
		'forms',
		'helpers.validations',
		'tradeServe.utils.login',
		'helpers.states',
		'helpers.titleBar',
		'helpers.googlePlace',
		'helpers.locationService',
		'helpers.uploadService',
		'helpers.permission',
		'administrative',
		'templateStore',
		'questionnaire',
		'ngFileUpload',
		'ui.utils.masks',
		'as.sortable',
		'dashboard',
		'vxWamp',
		'chat',
		'angularModalService',
		'headerMessages',
		'dispatchSummary',
		'dispatchSummary.table',
		'tradeServe.utils.telephony',
	]);

	app.config(['$locationProvider', '$urlRouterProvider', '$compileProvider', '$httpProvider', '$stateProvider',
		($locationProvider: ng.ILocationProvider, $urlRouterProvider: ng.ui.IUrlRouterProvider,
		 $compileProvider: ng.ICompileProvider, $httpProvider: ng.IHttpProvider, $stateProvider: ng.ui.IStateProvider) => {
			$stateProvider
				.state('zipSolutions', {
					url: '/?officeOrg&apptId&office&redirect',
					params: {
						officeOrg: { dynamic: true, squash: true, value: null,    type: 'int'    },
						apptId:    { dynamic: true, squash: true, value: null,    type: 'int'    },
						office:    { dynamic: true, squash: true, value: 'false', type: 'string' },
						redirect:  { dynamic: true, squash: true, value: null,    type: 'string' },
					},
				})
				.state('zipSolutions.old', {
					abstract: true,
				});

			$compileProvider.debugInfoEnabled(debugInfoEnabled);

			$locationProvider.html5Mode({
				enabled: true,
				requireBase: false,
				rewriteLinks: false
			});

			$httpProvider.defaults.headers.common['Content-Type'] = 'application/json';
			$urlRouterProvider.otherwise('/home/appointment');
		}]);

	app.constant('Constants', {
		apiUrl: api + 'v1/',
		debugInfoEnabled: debugInfoEnabled,
		version: version,
		isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
	});

	app.run(['$rootScope', '$state', '$http', 'LoginService', 'UserSession', 'PermissionService',
		($rootScope: AppRootScope, $state: ng.ui.IStateService,
		 	$http: ng.IHttpProvider, LoginService: App.Login.LoginService,
		 	UserSession: UserSession, PermissionService: App.Helpers.PermissionService) => {

		$http.defaults.headers.common['API-Key'] = LoginService.giveToken();

		$rootScope.$on('sessionChange', UserSession.checkSession);

		$rootScope.$on('$locationChangeSuccess', () => {
			try {
				document.querySelector('main').scrollTop = 0;
			} catch(e) {

			}
		});

		$rootScope.$on('$stateChangeStart', function(evt, to, params) {
			if (to.redirectTo) {
				evt.preventDefault();
				$state.go(to.redirectTo, params, {location: 'replace'})
			}
		});

		function S4() {
			return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
		}

		function generateGuid() {
			return (S4() + S4() + '-' + S4() + '-4' + S4().substr(0, 3) + '-' + S4() + '-' + S4() + S4() + S4()).toUpperCase();
		}

		$rootScope.app = {
			startAppLoading: function() {
				$rootScope.app.isAppLoading = true;
			},
			generateGuid: generateGuid,
			stopAppLoading: function() {
				$rootScope.app.isAppLoading = false;
			},
			setOrganization: (id) => {
				if (!id) {
					delete $http.defaults.headers.common['organization'];
				} else {
					$http.defaults.headers.common['organization'] = id;
				}
			},
			showAppHeader: () => {
				$rootScope.app.isHeaderShown = true;
			},
			hideAppHeader: () => {
				$rootScope.app.isHeaderShown = false;
			},
			getTitle: () => {
				return $state.current.data ? $state.current.data.title + ' - Zip Solutions Field App' : 'Zip Solutions Field App';
			},
			isHeaderShown: true,
			showTimeEvents: () => {},
			initElement: (selector: string) => angular.element(document.querySelector(selector)).css('display', ''),
			getClockedStatusColor: (timeClockStatus: boolean): string => {
				return PermissionService.hasPermission('web.time-clock.field.view')
					? App.TimeEvent.TimeEventViewController.getStatusColor()
					: PermissionService.hasAnyPermission(['web.field.right-nav.clock-in', 'web.field.right-nav.time-clock']) && timeClockStatus
						? 'green'
						: 'red';
			},
			getClockedStatusText: (): string => {
				return PermissionService.hasPermission('web.time-clock.field.view')
					? App.TimeEvent.TimeEventViewController.getEventTagName()
					: null;
			},
		}

		UserSession.checkSession();
	}]);

	angular.bootstrap(document, ['field'], {
		strictDi: true
	});
}